<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table class="slu-dashboard-label"
                                           :items="tableData"
                                           :fields="labelFields">
            <template v-slot:options>
                <b-button type="button" label="create-new-slu-label"
                          variant="primary" class="btn-add btn-add-slu-label"
                          v-b-modal="'add-slu-label-modal'">
                    {{$t('slu_dashboard.add_label')}}
                </b-button>
            </template>

            <template #cell(color)="data">
                <div :style="cssVars(data.item.color)" class="color-icon">
                    <i v-b-tooltip.hover :title="$t('slu_dashboard.color_code', {color: data.item.color})" class="fas fa-circle"></i>
                </div>
            </template>
            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button class="btn-edit btn-edit-slu-cohort btn-"
                              variant="primary-icon-only"
                              :title="$t('common.edit')"
                              v-b-tooltip.hover
                              @click="editSluLabel(data.item)">
                    </b-button>
                    <b-button class="btn-remove btn-remove-slu-cohort" variant="danger-icon-only"
                              @click="deleteLabel(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-add-slu-label-modal-component
            @updatelabels="addlabel($event)"
            ref="add-slu-label-modal">
        </design-2021-add-slu-label-modal-component>
        <design-2021-update-slu-label-modal-component
            @updateLabels="updatelabels($event)"
            ref="edit-slu-label-modal">
        </design-2021-update-slu-label-modal-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-slu-dashboard-labels-tab-component",
    props: ['sluLabelsIn'],
    data() {
        return {
            sluLabels: this.sluLabelsIn,
            labelFields: [
                {
                    key: 'color',
                    label: this.$t('common.colour'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name')
                },
                {
                    key: 'action',
                    label: this.$t('common.actions')
                }
            ]
        }
    },

    computed: {
        tableData() {
            return this.sluLabels;
        }
    },
    methods: {
        addlabel(label) {
            this.sluLabels.push(label)
        },
        editSluLabel(label) {
            this.$refs['edit-slu-label-modal'].show(label);
        },
        updatelabels(label) {
            this.sluLabels = this.sluLabels.map((slulabel) => {
                if (slulabel.id === label.id) {
                    const newLabel = {...slulabel, ...label};
                    return newLabel;
                } else {
                    return slulabel;
                }
            })
        },
        deleteLabel(labelId) {
            this.alert.confirm(this.$t('slu_dashboard.delete_label'), this.$t('slu_dashboard.are_you_sure_you_want_to_delete_this_label')).then((confirm) => {
                if (!confirm) {
                    return
                }
                this.alert.saving();
                this.axios.delete(this.routes.sluLabelsDelete(labelId)).then(
                    (response) => {
                        this.sluLabels = this.sluLabels.filter((item) => item.id !== labelId);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                )
            })
        },
        cssVars(color) {
            return {
                '--category-color': color
            }
        }
    }
}
</script>

<style scoped lang="scss">

.color-icon {
    font-size: $base-font-size;

    i {
        color: var(--category-color);
    }
}
</style>

export default {
}
</script>

<style scoped>

</style>
